export type WooCommerceAutoMessageKey =
  | 'order_placed'
  | 'order_processing'
  | 'order_completed'
  | 'order_cancelled'
  | 'order_refunded'
  | 'order_on_hold'
  | 'abandoned_cart'
  | 'new_customer';

export interface WooCommerceAutoMessageCatalogEntry {
  key: WooCommerceAutoMessageKey;
  title: string;
  description: string;
  icon: string;
  triggerType: string;
}

export const WOOCOMMERCE_AUTO_MESSAGES: WooCommerceAutoMessageCatalogEntry[] = [
  {
    key: 'order_placed',
    title: 'Order Placed',
    description: 'Sent as soon as a new WooCommerce order is created.',
    icon: 'shopping-bag',
    triggerType: 'order.placed',
  },
  {
    key: 'order_processing',
    title: 'Order Processing',
    description: 'Sent when payment is received and the order moves to processing.',
    icon: 'credit-card',
    triggerType: 'order.paid',
  },
  {
    key: 'order_completed',
    title: 'Order Completed',
    description: 'Sent when the order is marked complete / fulfilled.',
    icon: 'check-circle',
    triggerType: 'order.delivered',
  },
  {
    key: 'order_cancelled',
    title: 'Order Cancelled',
    description: 'Sent when an order is cancelled.',
    icon: 'x-circle',
    triggerType: 'order.cancelled',
  },
  {
    key: 'order_refunded',
    title: 'Refund Issued',
    description: 'Sent when a refund is issued against an order.',
    icon: 'rotate-ccw',
    triggerType: 'refund.created',
  },
  {
    key: 'order_on_hold',
    title: 'Order On Hold',
    description: 'Sent when an order is placed on hold (e.g. awaiting payment).',
    icon: 'shopping-cart',
    triggerType: 'checkout.updated',
  },
  {
    key: 'abandoned_cart',
    title: 'Abandoned Cart',
    description: 'Sent when a customer leaves items in their cart without checking out.',
    icon: 'shopping-cart',
    triggerType: 'checkout.updated',
  },
  {
    key: 'new_customer',
    title: 'New Customer',
    description: 'Sent when a new customer signs up on your WooCommerce store.',
    icon: 'user-plus',
    triggerType: 'customer.created',
  },
];
